// Text-notification events a number can opt into. Keys match
// server/src/services/notify.js. Missing key = on.
export const STAFF_EVENTS = [
  ['referral_received', 'New referral arrives', 'A firm sent your office a referral — accept within the hour'],
  ['referral_accepted', 'Referral accepted', 'A clinic accepted a referral you sent'],
  ['referral_booked', 'First visit booked', 'A referred patient has a visit on the calendar'],
  ['referral_expired', 'Referral expired', 'A clinic did not answer in time'],
  ['appointment_booked', 'Appointment booked', 'A patient or partner booked on your calendar'],
  ['appointment_cancelled', 'Appointment cancelled', 'A booked visit was cancelled'],
  ['appointment_no_show', 'No-show', 'A patient missed a visit'],
];

export const PATIENT_EVENTS = [
  ['appointment_booked', 'Booking confirmations', 'When a visit is booked for me'],
  ['appointment_reminder', 'Appointment reminders', 'The day before and the morning of'],
  ['appointment_changed', 'Changes to my appointments', 'Rescheduled or cancelled visits'],
  ['booking_invite', 'Booking invitations', 'A clinic accepted a referral and you can pick a time'],
];
